
















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({
  name:"Filters"
})
export default class ProposalFilters extends Vue {
  @Prop({ required: true }) readonly filters: object[];
}
